function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#F0F0F0",
  fillRule: "nonzero",
  stroke: "#0782B9",
  strokeWidth: 1.87,
  strokeOpacity: 0.407
}, React.createElement("path", {
  d: "M50.841 21.875s.277 4.538 2.492 6.738c0 8.937-10.106 7.7-15.09 12.787 1.246.688 2.63 1.238 4.43 1.788 3.184 1.1 6.784 2.475 9 5.637H81.3c0-14.3-17.721-8.387-17.721-20.212 2.215-2.2 2.492-6.738 2.492-6.738 1.661-2.475 2.215-4.95 1.661-5.912 2.492-5.088-2.492-7.563-.83-12.65-6.508-3.163-14.4-1.925-16.06 4.262-2.493 1.65-2.493 5.913-1.662 8.388-.554 1.1 0 3.437 1.661 5.912z"
}), React.createElement("path", {
  d: "M26.89 4.275c14.398 0 7.614 19.938 15.368 24.75-1.939 2.888-6.646 5.775-11.492 6.6 2.77 13.613 20.075 7.013 20.075 20.075H1c0-13.062 17.306-6.462 20.075-19.937-4.846-.963-9.553-3.85-11.491-6.6C17.198 24.35 8.476 9.775 20.106 7.3c.969-1.1 2.907-3.025 6.784-3.025z"
}));

var SvgInvitePeople = function SvgInvitePeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 83 57",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInvitePeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InvitePeople.a8e42c2f.svg";
export { ForwardRef as ReactComponent };